import React, { Component } from 'react';
import DataTable from "react-data-table-component";
import $ from "jquery";
import { ToastContainer, toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { tokenVerification, textDirection } from './Utils';
// import { Multiselect } from 'multiselect-react-dropdown';

class SurveyReminder extends Component {
    constructor() {
        super();
        this.state = {
            disabled: false,
            dataStartedProcessing: false,
            savingData: false,
            data: [],
            editedId: "-1",
            pageNum: null,
            paginationValue: 10,
            hidden: false,
            hideDeletePopup: false,
            hideDeleteSuccessPopup: false,
            options: [],
            selectedDaysName: [],
            selectedDays: [],
            reminderTime: "",
            editedDaysOfWeek: [],
            editedReminderTime: "",
            showModal: false,
            daysChanged: false,
            hideNotifyBtn: false,
            notificationData: {},
            hideSaveBtn: false,
            showDropdown: true,
            isLoading: true,
            noMatchingData: false,
            searchTerm: "",
            showTranslationModal: false,
            selectedReminderId: null,
            selectedLanguage: "es",
            translationLanguages: [],
            translationFields: {
                title: "",
                content: ""
            },
            autoTranslating: false,
            translationLoading: false,

        }
        this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
        this.editImageSrc = "./assets/images/edit2.png";
        this.userDetails = JSON.parse(localStorage.getItem("user_details"));
    }
    componentDidMount() {
        this.fetchSurveyReminder();
    }
    goBackFromSubTab = () => {
        var pageNum = this.props.location.state.pageNum;
        this.props.history.push({
            pathname: "/projectmgmt/survey",
            state: {
                pageNum: pageNum,
                surveyId: this.props.location.state.surveyId,
            }
        });
    }

    refreshData = (id) => {
        console.log("Resetting the data");
        this.state.data = [];
        this.state.isLoading = true;
        this.state.searchTerm = "";
        this.state.noMatchingData = false;
        this.state.editedId = "-1";
        this.state.disabled = false;
        this.state.hideNotifyBtn = false;
        this.setState(this.state);
        this.fetchSurveyReminder();
    }

    fetchSurveyReminder = () => {
        var thisController = this;

        $.ajax({
            url: "/my-jeeva-api/all-survey-Reminders",

            method: 'GET',
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
            },
            data: {
                surveyId: this.props.location.state.surveyId,
            },
            success: function (res) {
                if (res.success === true) {
                    var reminders = res.result;
                    thisController.state.disabled = false;
                    thisController.state.isLoading = false;
                    thisController.state.noMatchingData = false;
                    thisController.state.showLoader = true;
                    thisController.state.data = reminders;
                    thisController.setState(thisController.state);

                    // Fetch survey details to get surveyGroupId for language filtering
                    thisController.fetchSurveyDetails();
                } else {
                    // thisController.notifyError(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    tokenVerification();
                }
            }
        });
    }

    fetchSurveyDetails = () => {
        var thisController = this;
        $.ajax({
            url: "/my-jeeva-api/fetch-survey-with-id",
            method: 'GET',
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
            },
            data: {
                id: this.props.location.state.surveyId
            },
            success: function (res) {
                if (res.success === true && res.result) {
                    var surveyGroupId = res.result.surveyGroupId;
                    thisController.state.surveyGroupId = surveyGroupId;
                    thisController.setState(thisController.state);
                    // Fetch only enabled languages for this survey group
                    thisController.fetchTranslationLanguages(surveyGroupId);
                }
            },
            error: function (xhr) {
                console.error("Error fetching survey details");
                // Fallback to all languages if survey fetch fails
                thisController.fetchTranslationLanguages(null);
            }
        });
    }

    saveSurveyReminderApi = (props, e) => {
        var thisController = this;

        var title = document.getElementById("title" + props.id).innerText.trim();
        var content = document.getElementById("content" + props.id).innerText.trim();;
        var remIntervalMinutes = document.getElementById("remIntervalMinutes" + props.id).innerText.trim();

        if (thisController.state.reminderTime === "" || title === "" ||
            content === "" || remIntervalMinutes === "") {
            thisController.notifyMsgFieldEmpty();
        } else {
            var saveData = {
                surveyId: thisController.props.location.state.surveyId,
                surveyTitle: localStorage.getItem("surveyTitle"),
                timeOfDay: thisController.state.reminderTime,
                title: title,
                content: content,
                remIntervalMinutes: remIntervalMinutes,
            }
            $.ajax({
                url: "/my-jeeva-api/save-survey-Reminder",
                method: 'POST',
                data: JSON.stringify(saveData),
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': "application/json",

                },
                success: function (res) {
                    if (res.success === true) {
                        thisController.notifyAdded();
                        thisController.state.disabled = false;
                        thisController.state.hideNotifyBtn = false;
                        thisController.setState(thisController.state);
                        thisController.fetchSurveyReminder();
                    } else {
                        // thisController.notifyError();
                        thisController.state.disabled = false;
                    }
                    thisController.setState({ savingData: false });
                },
                error: function (xhr, status, error) {
                    if (xhr.status == 401) {
                        tokenVerification();
                    }
                }
            })
        }
    }



    CustomNoDataComponent = () => (
        <div style={{ padding: '20px', textAlign: 'center' }}>
            <p>There are no survey notifications set.</p>
        </div>
    );

    updateSurveyReminderApi(props, e) {

        var thisController = this;

        var updateData = {
            id: props.id,
            surveyId: thisController.props.location.state.surveyId,
            timeOfDay: document.getElementById("reminderTime" + props.id).value,
            title: document.getElementById("title" + props.id).innerText.trim(),
            content: document.getElementById("content" + props.id).innerText.trim(),
            remIntervalMinutes: document.getElementById("remIntervalMinutes" + props.id).innerText.trim()
        }
        $.ajax({
            url: "/my-jeeva-api/update-survey-Reminder",

            method: 'PATCH',
            data: JSON.stringify(updateData),
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
                'Content-Type': "application/json"
            },
            success: function (res) {
                if (res.success == true) {
                    thisController.state.editedId = "-1";
                    thisController.notifyUpdated();
                    thisController.state.disabled = false;
                    thisController.state.hideNotifyBtn = false;
                    thisController.state.daysChanged = false;
                    thisController.setState(thisController.state);
                    thisController.fetchSurveyReminder();
                } else {
                    thisController.state.disabled = false;
                    thisController.setState(thisController.state);
                }
            },
            error: function (xhr, status, error) {
                if (xhr.status == 401) {
                    tokenVerification();
                }
            }
        })
    }

    addNewReminder = () => {
        var thisController = this;
        thisController.state.paginationValue = thisController.state.paginationValue + 5;
        if (thisController.state.pageNum != 0) {
            thisController.setState({ pageNum: 0 })
        }
        this.state.data.unshift({
            id: '',
            journalId: '',
            timeOfDay: '',
            title: '',
            content: '',
            remIntervalMinutes: ''
        });
        this.setState({
            data: this.state.data,
            disabled: true,
            hideNotifyBtn: true,
            selectedDaysName: [],
            reminderTime: ""
        })
    }

    makeCelleditable(props, e) {
        this.markAsBeingEdited(props.id);
        this.state.editedDaysOfWeek = props.daysOfWeek;
        this.state.editedReminderTime = props.reminderTime;
        this.state.disabled = true;
        this.state.hideNotifyBtn = true;
        this.setState(this.state);

    }

    markAsBeingEdited(id) {
        this.state.editedId = id;
        var stateObj = this.state;
        this.setState(stateObj);
    }

    openDeletePopUp = (props) => {

        confirmAlert({
            title: 'Confirm to Delete',
            message: `Are you sure you want to delete ${props.title} ?`,
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => this.deleteSurveyReminderApi(props)
                },
                {
                    label: 'No',
                }
            ]
        });
    }

    deleteSurveyReminderApi = (props) => {
        let deleteRowViewController = this.state.data;
        let deleteApiViewController = this;
        var deleteConstructorVariables = this;
        var id = props.id;

        if (props.id == "") {
            deleteApiViewController.setState({ deleteRow: true });
            deleteConstructorVariables.setState({ hideDeletePopup: false });
            deleteConstructorVariables.setState({ hideDeleteSuccessPopup: true });
            deleteRowViewController.splice(props.id, 1);
        } else {
            $.ajax({
                url: "/my-jeeva-api/delete-survey-Reminder/" + id,

                method: 'DELETE',
                headers: {
                    "Authorization": "Bearer " + localStorage.getItem("access_token")
                },
                success: function (res) {

                    if (res.success === true) {
                        deleteApiViewController.setState({ deleteRow: true });
                        deleteConstructorVariables.setState({ hideDeletePopup: false });
                        deleteRowViewController.splice(props.id, 1);
                        deleteConstructorVariables.notifyDelete();
                        deleteConstructorVariables.refreshData();
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        tokenVerification();
                    }
                }
            });
        }
    }


    handleChangeTime = (row, e) => {
        this.state.reminderTime = e.target.value;
        if (row.timeOfDay !== "") {
            row.timeOfDay = e.target.value;
        }
        this.setState(this.state);
    };



    handleTitleChange = (e) => {
        this.setState({
            notificationData: {
                title: e.target.value
            }
        });
    }
    handleContentChange = (e) => {
        this.setState({
            notificationData: {
                content: e.target.value
            }
        });
    };

    handleChangeRemInterval = (e) => {
        this.setState({
            notificationData: {
                remIntervalMinutes: e.target.value
            }
        });
    }
    notifyAdded() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Notification has been added successfully</b>, {
            position: "top-center",

        });

    };

    notifyNotificationAdded() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Notification has been saved successfully</b>, {
            position: "top-center",

        });
    }
    notifyNotificationUpdted() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Notification has been updated successfully</b>, {
            position: "top-center",

        });
    }
    notifyUpdated() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp; Notification has been updated successfully</b>, {
            position: "top-center",

        });
    }

    notifyImproperName() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please provide a valid name</b>, {
            position: "top-center"
        });
    }

    notifyMsgFieldEmpty() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please fill all the fields</b>, {
            position: "top-center"
        });

    }

    notifyError() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;Oops! Error occurred.Please try again</b>, {
            position: "top-center"
        });
    }

    notifyReminderCloned() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;Notification copied successfully.</b>, {
            position: "top-center"
        });
    }

    notifyDelete() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp; Notification deleted successfully</b>, {
            position: "top-center",
        });
    }

    handleClonedData = (row) => {
        this.cloneReminder(row);
        this.state.editableModeOn = true;
        this.setState(this.state);
    };

    cloneReminder = (row) => {
        var thisController = this;

        var saveData = {
            surveyId: row.surveyId,
            daysOfWeek: row.daysOfWeek,
            timeOfDay: row.timeOfDay,
            surveyTitle: row.surveyTitle,
            id: row.id,
            title: row.title,
            content: row.content,
            remIntervalMinutes: row.remIntervalMinutes
        };
        $.ajax({
            url: "/my-jeeva-api/clone-survey-reminder",
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
                "Content-Type": "application/json",
            },
            data: JSON.stringify(saveData),

            success: function (res) {
                if (res.success === true) {
                    thisController.setState(thisController.state);
                    thisController.notifyReminderCloned();
                    thisController.fetchSurveyReminder();
                    thisController.state.disabled = false;
                    thisController.setState(thisController.state);
                } else {
                    thisController.state.disabled = false;
                    thisController.setState(thisController.state);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "";
                }
            },
        });
    }





    onPageChange = (e) => {
        this.setState({ pageNum: e })
    }

    caseInsensitiveSort = (field) => (rowA, rowB) => {

        var a;
        var b;
        if (field === "remIntervalMinutes") {
            a = rowA[field] ? rowA[field] : "";
            b = rowB[field] ? rowB[field] : "";
        } else {
            a = rowA[field] ? rowA[field].toLowerCase() : '';
            b = rowB[field] ? rowB[field].toLowerCase() : '';
        }

        if (a > b) {
            return 1;
        }
        if (b > a) {
            return -1;
        }
        return 0;
    };

    handleSearch = (event) => {
        var thisController = this;
        var searchTerm = event.target.value;
        thisController.state.searchTerm = searchTerm;
        thisController.state.isLoading = true;
        thisController.state.data = [];
        thisController.setState(thisController.state);

        if (!thisController.state.searchTerm || thisController.state.searchTerm.trim() === "") {
            thisController.setState({
                searchTerm: "",
            });
            thisController.fetchSurveyReminder();
        }
        else {
            $.ajax({
                url: "/my-jeeva-api/search-survey-reminder-data",
                method: "GET",
                data: {
                    surveyId: this.props.location.state.surveyId,
                    searchTerm: searchTerm
                },
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                },

                success: function (res) {
                    if (res.success === true) {
                        if (res.result.length > 0) {
                            thisController.state.data = [];
                            thisController.setState(thisController.state);
                            thisController.state.data = res.result;
                            thisController.state.isLoading = false;
                            thisController.state.noMatchingData = false;
                            thisController.setState(thisController.state);
                        } else {
                            thisController.state.noMatchingData = true;
                            thisController.state.isLoading = false;
                            thisController.setState(thisController.state);
                        }
                    }
                },
                error: function (xhr) {

                },
            });
        }

    };

    fetchTranslationLanguages = (procedureId) => {
        var thisController = this;
        var url = procedureId
            ? `/my-jeeva-api/procedure/${procedureId}/languages/enabled`
            : "/my-jeeva-api/translation-edit/languages";

        $.ajax({
            url: url,
            method: "GET",
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
            },
            success: function (res) {
                if (res.success === true && Array.isArray(res.result)) {
                    // Filter out English and map to displayName format
                    var languages = res.result
                        .filter(lang => lang.code && lang.code.toLowerCase() !== 'en')
                        .map(lang => ({
                            code: lang.code.toLowerCase(),
                            displayName: (lang.englishName || lang.displayName) + '(' + (lang.name || lang.englishName) + ')'
                        }));
                    thisController.setState({ translationLanguages: languages });
                } else if (Array.isArray(res)) {
                    // Handle direct array response
                    var languages = res
                        .filter(lang => lang.code && lang.code.toLowerCase() !== 'en')
                        .map(lang => ({
                            code: lang.code.toLowerCase(),
                            displayName: lang.name || lang.displayName || lang.englishName
                        }));
                    thisController.setState({ translationLanguages: languages });
                }
            },
            error: function (xhr) {
                console.error("Error fetching languages");
            }
        });
    };

    openTranslationModal = (reminder) => {
        this.state.selectedReminderId = reminder.id;
        this.state.showTranslationModal = true;
        this.state.selectedLanguage = "es";
        this.setState(this.state);
        // If languages haven't been loaded yet, fetch them now
        if (!this.state.translationLanguages || this.state.translationLanguages.length === 0) {
            if (this.state.surveyGroupId) {
                this.fetchTranslationLanguages(this.state.surveyGroupId);
            }
        }
        this.fetchTranslation(reminder.id, "es");
    };

    closeTranslationModal = () => {
        this.state.showTranslationModal = false;
        this.state.selectedReminderId = null;
        this.state.translationFields = { title: "", content: "" };
        this.setState(this.state);
    };

    fetchTranslation = (reminderId, language) => {
        var thisController = this;
        thisController.state.translationLoading = true;
        thisController.setState(thisController.state);

        $.ajax({
            url: "/my-jeeva-api/translation-edit/surveyreminder/" + reminderId,
            method: "GET",
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
            },
            data: {
                language: language
            },
            success: function (res) {
                if (res.success === true) {
                    var fields = res.result.fields || { title: "", content: "" };
                    thisController.state.translationFields = fields;
                    thisController.state.translationLoading = false;
                    thisController.setState(thisController.state);

                    // Auto-translate if fields are empty
                    if (!fields.title && !fields.content) {
                        thisController.autoTranslateReminder(reminderId, language);
                    }
                }
            },
            error: function (xhr) {
                thisController.state.translationLoading = false;
                thisController.setState(thisController.state);
                console.error("Error fetching translation");
            }
        });
    };

    autoTranslateReminder = (reminderId, language) => {
        var thisController = this;
        var reminder = thisController.state.data.find(r => r.id === reminderId);
        if (!reminder) return;

        thisController.state.autoTranslating = true;
        thisController.setState(thisController.state);

        // Auto-translate title
        if (reminder.title) {
            $.ajax({
                url: "/my-jeeva-api/translation-edit/auto-translate?language=" + language + "&sourceText=" + encodeURIComponent(reminder.title),
                method: "POST",
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': "application/json",
                },
                success: function (res) {
                    if (res.success === true) {
                        thisController.state.translationFields.title = res.result.translatedText;
                        thisController.setState(thisController.state);
                    }
                },
                error: function (xhr) {
                    console.error("Error auto-translating title");
                }
            });
        }

        // Auto-translate content
        if (reminder.content) {
            $.ajax({
                url: "/my-jeeva-api/translation-edit/auto-translate?language=" + language + "&sourceText=" + encodeURIComponent(reminder.content),
                method: "POST",
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': "application/json",
                },
                success: function (res) {
                    if (res.success === true) {
                        thisController.state.translationFields.content = res.result.translatedText;
                        thisController.state.autoTranslating = false;
                        thisController.setState(thisController.state);
                    }
                },
                error: function (xhr) {
                    thisController.state.autoTranslating = false;
                    thisController.setState(thisController.state);
                    console.error("Error auto-translating content");
                }
            });
        }
    };

    handleTranslationFieldChange = (fieldName, value) => {
        this.state.translationFields[fieldName] = value;
        this.setState(this.state);
    };

    handleLanguageChange = (e) => {
        this.state.selectedLanguage = e.target.value;
        this.setState(this.state);
        this.fetchTranslation(this.state.selectedReminderId, e.target.value);
    };

    saveTranslation = () => {
        var thisController = this;
        var reminderId = thisController.state.selectedReminderId;
        var language = thisController.state.selectedLanguage;

        // Log the payload being sent
        console.log("[SAVE-TRANSLATION] Sending payload:", thisController.state.translationFields);

        $.ajax({
            url: "/my-jeeva-api/translation-edit/surveyreminder/" + reminderId + "?language=" + language,
            method: "PUT",
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
                'Content-Type': "application/json",
            },
            data: JSON.stringify(thisController.state.translationFields),
            success: function (res) {
                console.log("[SAVE-TRANSLATION] Response received:", res);
                if (res.success === true) {
                    // Verify the saved data by checking if the response contains the fields
                    const savedFields = res.result && res.result.fields;
                    if (savedFields && savedFields.content === thisController.state.translationFields.content) {
                        console.log("[SAVE-TRANSLATION] ✓ Content field saved correctly");
                    } else if (savedFields) {
                        console.warn("[SAVE-TRANSLATION] ⚠ Response fields don't match sent fields", {
                            sent: thisController.state.translationFields,
                            received: savedFields
                        });
                    }
                    thisController.notifyTranslationSaved();
                    thisController.closeTranslationModal();
                } else {
                    console.error("[SAVE-TRANSLATION] ✗ Response success is false:", res);
                    thisController.notifyError();
                }
            },
            error: function (xhr) {
                console.error("[SAVE-TRANSLATION] ✗ Request failed:", xhr);
                if (xhr.responseJSON) {
                    console.error("[SAVE-TRANSLATION] Error response:", xhr.responseJSON);
                }
                thisController.notifyError();
            }
        });
    };

    notifyTranslationSaved() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Translation has been saved successfully</b>, {
            position: "top-center",
        });
    }

    render() {
        const { data } = this.state;
        const columns = [
            {
                name: <b style={{ fontSize: "16px" }}> Time </b>,
                sortable: true,
                sortFunction: this.caseInsensitiveSort('timeOfDay'),
                width: "8vw",
                selector: (row) => (
                    <div>
                        <div
                            style={{
                                display:
                                    row.id == "" ? "none" : row.id != this.state.editedId
                                        ? "block"
                                        : "none",
                            }}
                            id="appearance-for-selected-days"
                        >
                            {row.timeOfDay}
                        </div>
                        <div
                            style={{
                                display:
                                    row.id == "" ? "block" : row.id != this.state.editedId
                                        ? "none"
                                        : "block",
                            }}
                        >
                            <input
                                type="time"
                                className="form-control col-11"
                                id={"reminderTime" + row.id}
                                name="time"
                                placeholder="Enter Time"
                                value={row.timeOfDay ? row.timeOfDay : this.state.reminderTime}
                                style={{
                                    width: "95%",
                                    cursor: "pointer",
                                    border: "1px solid #D2D4DC",
                                    borderRadius: "4px",
                                    border:
                                        row.id == "" || row.id == this.state.editedId
                                            ? "1px solid #D2D4DC"
                                            : "none",
                                    borderRadius: row.id == "" ? "2px" : "none",
                                }}
                                onChange={(e) => this.handleChangeTime(row, e)}
                                contentEditable={
                                    row.id === "" || row.id !== this.state.editedId ? "plaintext-only" : true
                                }

                            />
                        </div>

                    </div>
                ),
            },
            {
                name: <b style={{ fontSize: "16px" }}>Notification Title</b>,
                sortable: true,
                sortFunction: this.caseInsensitiveSort('title'),
                selector: (row) => (
                    <div>
                        <div
                            className="textarea"
                            style={{
                                background: "white",
                                height: "2.7em",
                                resize: "none",
                                paddingLeft: "2px",
                                paddingTop: "6px",
                                width: "100%",
                                border:
                                    row.id == "" || row.id == this.state.editedId
                                        ? "1px solid #D2D4DC"
                                        : "none",
                                borderRadius: row.id == "" ? "2px" : "none",
                                overflowY: "scroll"
                            }}
                            //   onInput={(e) => { this.handleDescriptionChange(e, row) }}
                            id={"title" + row.id}
                            contentEditable={
                                !(row.id == "" ? false : row.id != this.state.editedId)
                                    ? "plaintext-only"
                                    : false
                            }
                        >
                            {row.title}
                        </div>
                    </div>
                ),
            },

            {
                name: <b style={{ fontSize: "16px" }}>Notification Content</b>,
                width: "18vw",
                sortable: true,
                sortFunction: this.caseInsensitiveSort('content'),
                selector: (row) => (
                    <div>
                        <div
                            className="textarea"
                            style={{
                                background: "white",
                                height: "2.7em",
                                resize: "none",
                                paddingLeft: "2px",
                                paddingTop: "6px",
                                width: "100%",
                                border:
                                    row.id == "" || row.id == this.state.editedId
                                        ? "1px solid #D2D4DC"
                                        : "none",
                                borderRadius: row.id == "" ? "2px" : "none",
                                overflowY: "scroll"
                            }}
                            //   onInput={(e) => { this.handleDescriptionChange(e, row) }}
                            id={"content" + row.id}
                            contentEditable={
                                !(row.id == "" ? false : row.id != this.state.editedId)
                                    ? "plaintext-only"
                                    : false
                            }
                        >
                            {row.content}
                        </div>
                    </div>
                ),
            },
            {
                name: <b style={{ fontSize: "16px" }}>Interval Minutes</b>,
                ortable: true,
                sortFunction: this.caseInsensitiveSort('remIntervalMinutes'),
                width: "10vw",
                selector: (row) => (
                    <div>
                        <div
                            className="textarea"
                            style={{
                                background: "white",
                                height: "2.7em",
                                resize: "none",
                                paddingLeft: "2px",
                                paddingTop: "6px",
                                width: "100%",
                                border:
                                    row.id == "" || row.id == this.state.editedId
                                        ? "1px solid #D2D4DC"
                                        : "none",
                                borderRadius: row.id == "" ? "2px" : "none",
                            }}
                            id={"remIntervalMinutes" + row.id}
                            contentEditable={
                                !(row.id == "" ? false : row.id != this.state.editedId)
                                    ? "plaintext-only"
                                    : false
                            }
                        >
                            {row.remIntervalMinutes}
                        </div>
                    </div>
                ),
            },
            {
                name: <b style={{ fontSize: '16px' }}>Actions</b>,
                width: "14vw",
                selector: (props) => (
                    <div id="action">
                        <button
                            //className="btn2 table-action-button "
                            style={{
                                backgroundColor: "#ffffff", border: "none"
                            }}
                            disabled={(this.userDetails["userRole"] === "PHYSICIAN" &&
                                this.userDetails["emailId"] !== this.props.location.state.createdByEmail)}
                        >
                            <img className="img-responsive"
                                style={{
                                    marginTop: '8px',
                                    backgroundColor: this.userDetails["userRole"] === "PHYSICIAN" &&
                                        this.userDetails["emailId"] !== this.props.location.state.createdByEmail
                                        ? "#282a6596"
                                        : "#282a65",
                                    borderRadius: '5px',
                                    padding: '1px'
                                }}
                                title={props.id == "" || (props.id == this.state.editedId) ? 'Save' : 'Edit'}
                                src={(props.id == "") ?
                                    this.saveImageSrc : ((props.id != this.state.editedId) ?
                                        this.editImageSrc : this.saveImageSrc)}

                                disabled={this.userDetails["userRole"] === "PHYSICIAN" &&
                                    JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("journalCreatedBy")}
                                onClick={this.userDetails["userRole"] === "PHYSICIAN" &&
                                    JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("journalCreatedBy") ? null :
                                    (e) => {
                                        (props.id == "") ?
                                            this.saveSurveyReminderApi(props, e) :
                                            (props.id == this.state.editedId) ?
                                                this.updateSurveyReminderApi(props, e) :
                                                this.makeCelleditable(props, e);
                                    }}
                            />
                        </button>
                        <button
                            style={{
                                backgroundColor: "#ffffff",
                                border: "none",
                                marginTop: '-9px', marginLeft: '-6px'
                            }}
                            disabled={(this.userDetails["userRole"] === "PHYSICIAN" &&
                                this.userDetails["emailId"] !== this.props.location.state.createdByEmail)}
                            title="Delete">
                            <img className="img-responsive"
                                style={{
                                    marginTop: '6px',
                                    backgroundColor: (this.userDetails["userRole"] === "PHYSICIAN" &&
                                        this.userDetails["emailId"] !== this.props.location.state.createdByEmail)
                                        ? "#282a6596"
                                        : "#282a65",
                                    borderRadius: '5px',
                                    padding: '1px'
                                }}
                                src={"./assets/images/baseline_delete_white_24dp.png"}
                                disabled={this.userDetails["userRole"] === "PHYSICIAN" &&
                                    JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("journalCreatedBy")}
                                onClick={this.userDetails["userRole"] === "PHYSICIAN" &&
                                    JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("journalCreatedBy") ? null :
                                    () => (props.id) === '' ?
                                        this.fetchSurveyReminder() :
                                        this.openDeletePopUp(props)}
                            />
                        </button>
                        <button
                            style={{
                                backgroundColor: "#ffffff",
                                border: "none",
                                display: props.id == "" || props.id == this.state.editedId ? "none" : "inline"
                            }}
                            disabled={this.userDetails["userRole"] === "PHYSICIAN" &&
                                JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("journalCreatedBy")}
                            onClick={this.userDetails["userRole"] === "PHYSICIAN" &&
                                JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("journalCreatedBy") ? null :
                                (e) => {
                                    !props.id == ""
                                        ? this.handleClonedData(props)
                                        : this.makeCelledit(props, e);
                                }}
                        >
                            <img
                                className="img-responsive"
                                title="Copy"
                                style={{
                                    padding: "2px",
                                    height: "2rem",
                                    marginTop: '6px',
                                    backgroundColor: this.userDetails["userRole"] === "PHYSICIAN" &&
                                        JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("journalCreatedBy")
                                        ? "#282a6596"
                                        : "#282a65",
                                    borderRadius: '5px',
                                    padding: '1px'
                                }}
                                src={"./assets/images/copy-64.png"}
                            />
                        </button>
                        <button
                            style={{
                                backgroundColor: "#ffffff",
                                border: "none",
                                display: props.id == "" || props.id == this.state.editedId ? "none" : "inline",
                                marginTop: '-9px', marginLeft: '-6px'
                            }}
                            disabled={this.userDetails["userRole"] === "PHYSICIAN" &&
                                JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("journalCreatedBy")}
                            title="Translate"
                            onClick={this.userDetails["userRole"] === "PHYSICIAN" &&
                                JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("journalCreatedBy") ? null :
                                () => this.openTranslationModal(props)}
                        >
                            <img
                                className="img-responsive"
                                title="Translate"
                                style={{
                                    padding: "2px",
                                    height: "2rem",
                                    marginTop: '6px',
                                    backgroundColor: this.userDetails["userRole"] === "PHYSICIAN" &&
                                        JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("journalCreatedBy")
                                        ? "#282a6596"
                                        : "#282a65",
                                    borderRadius: '5px',
                                    padding: '1px'
                                }}
                                src={"./assets/images/translate_white_24dp.svg"}
                            />
                        </button>

                    </div>
                ),

            },

        ];
        return (
            <div style={{ background: "#F9F9FB", marginRight: "1%" }}>
                {/* for toaster */}
                <link rel="stylesheet" href="assets/css/ReactToastify.css" />
                {/* for reactTable */}
                <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
                {/*for dialog component */}
                <link href="assets/css/ej2-base.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                <link href="assets/css/screenResolution.css" rel="stylesheet" />
                {/* Font Awesome Icons */}
                <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                {/* IonIcons */}
                <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                {/* Select2 */}
                <link rel="stylesheet" href="plugins/select2/select2.min.css" />
                <link rel="stylesheet" href="assets/css/toggleButton.css" />
                <link rel="stylesheet" href="assets/css/buttonForm.css" />
                <link rel="stylesheet" href="./assets/css/styles.css" />
                <link rel="stylesheet" href="assets/css/adminlte.css" />
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row">
                        </div>
                        <div className="row">
                            <div className="col-sm-4" style={{ marginTop: '16px' }}  >
                                <img src="assets/images/arrow.svg"
                                    style={{ paddingRight: "30%", cursor: 'pointer' }}
                                    onClick={this.goBackFromSubTab}
                                />
                            </div>
                            <div style={{ marginLeft: "-27vw", marginTop: "0.6vh" }}>
                                <h6 className="nav-item" style={{ color: '#282a65', textAlign: 'center', marginTop: '16px' }}>
                                    Notification for  {localStorage.getItem("surveyTitle")}</h6>
                            </div>

                        </div>
                    </div>
                    <br />
                    <div className="row" style={{
                        justifyContent: "flex-end",
                        marginRight: "1px"
                    }}>
                        <div
                            Align='right'
                            style={{ marginTop: "2.6vh", }}>
                            <input
                                type="text"
                                style={{
                                    width: "12vw",
                                    border: "2px solid #777676",
                                    borderRadius: "10px",
                                    padding: "10px",
                                    height: "0.7vw"
                                }}
                                value={this.state.searchTerm}
                                onChange={this.handleSearch}
                                placeholder="Search ..."
                            />
                        </div>
                        {/* Add button */}
                        <div Align='right' style={{ marginLeft: "10vw", marginTop: "1.5vh" }}>
                            <button className="btn action-button "
                                title="Add"
                                id="addMsg"
                                disabled={(this.userDetails["userRole"] === "PHYSICIAN" &&
                                    this.userDetails["emailId"] !== this.props.location.state.createdByEmail)}
                                onClick={this.state.disabled ? this.notifyMsgFieldEmpty : this.addNewReminder}
                            >
                                <img src="assets/images/add_white_24dp.png" />
                            </button>
                            <button
                                onClick={this.refreshData}
                                title="Refresh"
                                className="btn action-button">
                                <img src="./assets/images/refresh_white_24dp.png"></img>
                            </button>
                        </div>
                    </div>
                    <div className="row" style={{ marginLeft: '15px', marginTop: '10px' }}>
                        <div className="col-lg-12 ">
                            <div className="card">
                                {this.state.isLoading && (
                                    <div style={{ padding: '20px', textAlign: 'center' }}>
                                        <p>Loading ...</p>
                                    </div>
                                )}
                                {!this.state.isLoading && this.state.data.length === 0 && !this.state.noMatchingData && (
                                    <div style={{ padding: '20px', textAlign: 'center' }}>
                                        <p>There are no survey notifications set.</p>
                                    </div>
                                )}
                                {(this.state.data.length > 0 && !this.state.noMatchingData) &&
                                    (<DataTable
                                        data={this.state.data}
                                        columns={columns}
                                        defaultPageSize={10}
                                        pageSizeOptions={[5, 10, 15]}
                                        pagination={this.state.paginationValue}
                                        onPageChange={this.onPageChange}
                                        page={this.state.pageNum}
                                        noDataComponent={<this.CustomNoDataComponent />}
                                    />)
                                }
                            </div>
                            <ToastContainer className="Toast-at-center" />
                        </div>
                    </div>
                    <div className='card'>
                        {this.state.noMatchingData &&
                            <div style={{ padding: '20px', textAlign: 'center', boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)" }}>
                                <p>No matching options found ...</p>
                            </div>
                        }
                    </div>

                    {/* Translation Modal */}
                    {this.state.showTranslationModal && (
                        <div
                            style={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                backgroundColor: "rgba(0, 0, 0, 0.6)",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                zIndex: 1050
                            }}
                            onClick={this.closeTranslationModal}
                        >
                            <div
                                style={{
                                    backgroundColor: "white",
                                    borderRadius: "8px",
                                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
                                    width: "500px",
                                    maxHeight: "90vh",
                                    overflow: "auto",
                                    zIndex: 1051
                                }}
                                onClick={(e) => e.stopPropagation()}
                            >
                                {/* Modal Header */}
                                <div style={{
                                    padding: "20px 25px",
                                    borderBottom: "1px solid #e0e0e0",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center"
                                }}>
                                    <h4 style={{ margin: 0, fontSize: "18px", fontWeight: "600", color: "#282a65" }}>
                                        Translate Survey Notification
                                    </h4>
                                    <button
                                        type="button"
                                        onClick={this.closeTranslationModal}
                                        style={{
                                            background: "none",
                                            border: "none",
                                            fontSize: "24px",
                                            cursor: "pointer",
                                            color: "#666",
                                            padding: 0
                                        }}
                                    >
                                        ×
                                    </button>
                                </div>

                                {/* Modal Body */}
                                <div style={{ padding: "25px" }}>
                                    <div style={{ marginBottom: "20px" }}>
                                        <label style={{ display: "block", marginBottom: "8px", fontWeight: "600", color: "#333", fontSize: "14px" }}>Language</label>
                                        <select
                                            value={this.state.selectedLanguage}
                                            onChange={this.handleLanguageChange}
                                            style={{
                                                width: "100%",
                                                padding: "10px 12px",
                                                borderRadius: "4px",
                                                border: "1px solid #d0d0d0",
                                                fontSize: "14px",
                                                backgroundColor: "#fff",
                                                boxSizing: "border-box"
                                            }}
                                        >
                                            {this.state.translationLanguages.map((lang) => (
                                                <option key={lang.code} value={lang.code}>
                                                    {lang.displayName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    {this.state.translationLoading || this.state.autoTranslating ? (
                                        <div style={{ padding: '40px 20px', textAlign: 'center' }}>
                                            <p style={{ color: "#666", fontSize: "14px", margin: 0 }}>
                                                {this.state.autoTranslating ? "🔄 Auto-translating..." : "Loading translation..."}
                                            </p>
                                        </div>
                                    ) : (
                                        <div>
                                            <div style={{ marginBottom: "20px" }}>
                                                <label style={{ display: "block", marginBottom: "8px", fontWeight: "600", color: "#333", fontSize: "14px" }}>Notification Title</label>
                                                <textarea
                                                    dir={textDirection(this.state.selectedLanguage)}
                                                    value={this.state.translationFields.title}
                                                    onChange={(e) => this.handleTranslationFieldChange('title', e.target.value)}
                                                    style={{
                                                        width: "100%",
                                                        height: "60px",
                                                        padding: "10px 12px",
                                                        borderRadius: "4px",
                                                        border: "1px solid #d0d0d0",
                                                        fontFamily: "Arial, sans-serif",
                                                        fontSize: "13px",
                                                        resize: "vertical",
                                                        boxSizing: "border-box"
                                                    }}
                                                    placeholder="Enter translation for notification title"
                                                />
                                            </div>

                                            <div style={{ marginBottom: "0" }}>
                                                <label style={{ display: "block", marginBottom: "8px", fontWeight: "600", color: "#333", fontSize: "14px" }}>Notification Content</label>
                                                <textarea
                                                    dir={textDirection(this.state.selectedLanguage)}
                                                    value={this.state.translationFields.content}
                                                    onChange={(e) => this.handleTranslationFieldChange('content', e.target.value)}
                                                    style={{
                                                        width: "100%",
                                                        height: "90px",
                                                        padding: "10px 12px",
                                                        borderRadius: "4px",
                                                        border: "1px solid #d0d0d0",
                                                        fontFamily: "Arial, sans-serif",
                                                        fontSize: "13px",
                                                        resize: "vertical",
                                                        boxSizing: "border-box"
                                                    }}
                                                    placeholder="Enter translation for notification content"
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* Modal Footer */}
                                <div style={{
                                    padding: "20px 25px",
                                    borderTop: "1px solid #e0e0e0",
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    gap: "10px"
                                }}>
                                    <button
                                        type="button"
                                        onClick={this.closeTranslationModal}
                                        style={{
                                            padding: "10px 20px",
                                            backgroundColor: "#f5f5f5",
                                            border: "1px solid #d0d0d0",
                                            borderRadius: "4px",
                                            cursor: "pointer",
                                            fontSize: "14px",
                                            fontWeight: "500",
                                            color: "#333"
                                        }}
                                    >
                                        Close
                                    </button>
                                    <button
                                        type="button"
                                        onClick={this.saveTranslation}
                                        disabled={this.state.translationLoading || this.state.autoTranslating}
                                        style={{
                                            padding: "10px 24px",
                                            backgroundColor: "#282a65",
                                            color: "white",
                                            border: "none",
                                            borderRadius: "4px",
                                            cursor: this.state.translationLoading || this.state.autoTranslating ? "not-allowed" : "pointer",
                                            fontSize: "14px",
                                            fontWeight: "500",
                                            opacity: this.state.translationLoading || this.state.autoTranslating ? 0.6 : 1
                                        }}
                                    >
                                        Save Translation
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        )
    }

}

export default SurveyReminder;


// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/SurveyReminder.js